import React from "react";
import Navbar from "../components/layout/header/Navbar";
import Layout from "../components/layout/Layout";
import PageHeader from "../components/team/PageHeader";
import Footer from "../components/layout/footer/Footer";
import CabeceraCostaAtlantica from "../components/destinosSecciones/CabeceraCostaAtlantica";
import HoteleriaCostaAtlanticaSecundario from "../components/hoteleria/HoteleriaCostaAtlanticaSecundario";
import Transporte from "../components/Transporte/Transporte";
import VideoPromoDestino from "../components/promo/VideoPromoDestino";
import DiversionCostaSec from "../components/diversion/DiversionCostaSec";
import AsistenciaMedica from "../components/AsistenciaMedica/AsistenciaMedica";

export default function SecCostaAtlantica() {
  return (
    <Layout>
      <Navbar darkBg />
      <PageHeader
        background={"assets/img/mardelplata/mar-del-plata2.jpg"}
        HeaderTitle="Costa Atlántica"
        Parent="secundarios"
        PageTitle="Costa Atlántica"
      />
      <CabeceraCostaAtlantica destino={"Costa Atlántica"} />
      <VideoPromoDestino
        background="assets/img/mardelplata/mar-del-plata.jpg"
        YoutubeVideoId={null}
        TextoPromo="Costa Atlántica, tu viaje de egresados."
      />
      {/* Para cambiar hoteleria y Galeria */}
      <HoteleriaCostaAtlanticaSecundario />
      <DiversionCostaSec hasBg={true} />
      {/*  */}
      <Transporte />
      <AsistenciaMedica bgColor />
      <Footer />
    </Layout>
  );
}
